import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'

const FetchConversationWrapper = ({ match, conversations, children }) => {
  const conversationId = match?.params?.conversationId

  useEffect(() => {
    if (conversationId && conversationId !== 'new') {
      const id = parseInt(conversationId, 10)
      if (!isNaN(id)) {
        conversations.getConversation(id)
      }
    }
  }, [conversationId, conversations])

  return children || null
}

export default flow(
  withRouter,
  observer,
  inject(({ mst: { conversations } }) => ({ conversations }))
)(FetchConversationWrapper)
